module.exports = __webpack_public_path__ + "img/community.af2f3ee5.svg";